// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-main[data-v-266e12b3]{padding-bottom:0!important}.v-navigation-drawer[data-v-266e12b3]{max-height:100%!important}.posAbs[data-v-266e12b3]{position:absolute}.desktopLogo[data-v-266e12b3]{margin-top:0!important;width:256px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
